module.exports = __webpack_public_path__ + "img/CN-flag.787c5290.svg";